export const SESSION_TIMEOUT_THRESHOLD = 300000;

export function setAuthToken(token) {
    if (token !== null) {
        localStorage.setItem('token', JSON.stringify(token));
    } else {
        clearAuthToken();
    }
}

export function getApiBase() {
    const API = {
        'localhost': 'https://virtserver.swaggerhub.com/devnow/Kind/1.0.0',
    };

    return API[window.location.hostname] || API['localhost'];
}

export function getAuthToken() {
    const token = localStorage.getItem('token');
    if (token !== null && token !== undefined) {
        return JSON.parse(token);
    } else {
        return null;
    }
}

export function clearAuthToken() {
    return localStorage.removeItem('token');
}

export function tokenValid(expirationDate) {
    return (expirationDate && (expirationDate - Date.now() > SESSION_TIMEOUT_THRESHOLD));
}

export function encodeDataToForm(data) {
    let formData = [];
    for (const property in data) {
        if (property) {
            const encodedKey = encodeURIComponent(property);
            const encodedValue = encodeURIComponent(data[property]);
            formData.push(encodedKey + '=' + encodedValue);
        }
    }
    formData = formData.join('&');
    return formData;
}


// WEBPACK FOOTER //
// ./src/api/utilities/utilities.js